<template>
  <b-container fluid>
    <div class="row">
      <div class="col-lg-12">
        <ProjectList
          :metas="metas"
          :listItems="items"
          :ems="ems"
          :showProjectFilter="clonedItems.length > 0" />
      </div>
    </div>
  </b-container>
</template>

<script>
import { format as dateFormat } from 'date-fns'
import Services from '../../services/main.service.vue'
import ProjectList from './projects-components/ProjectList.vue'

export default {
  name: 'ProjectsComponent',
  components: {
    ProjectList
  },
  data() {
    return {
      showFeeCheckbox: false,
      clonedItems: [], // using for filtering
      items: [],
      ems: [],
      filteredBy: null,
      metas: {}
    }
  },
  mounted() {
    this.getProjectsMetas()
    this.fetchData()
    this.$root.$on('tab_projects_refresh', this.fetchData)
    this.$root.$on('add-new', this.addNew)
    this.$root.$on('save-new', this.saveNew)
    this.$root.$on('update-project', this.updateProject)
    this.$root.$on('show-fee-cols', this.showFeeCols)
    this.$root.$on('filter-project-type', this.filterProjectType)
    this.$root.$on('search-project', this.searchProject)
  },
  methods: {
    async getProjectsMetas() {
      const { status, data } = await Services.Projects.Admin.getMetas()
      if (status === 200) {
        this.metas = data.content.metas
      }
    },
    async fetchData() {
      this.filteredBy = null
      // GET METAS
      await this.getProjectsMetas()
      this.items = []
      this.clonedItems = []
      const Projects = await Services.Projects.Admin.getProjects()
      if (Projects.status == 200) {
        const systemProjects = Projects.data.content
          .filter((itm) => itm.meta.system)
          .map((itm) => {
            itm.source = itm.meta?.partner ?? ''
            itm._new = false
            itm._edit = false
            return itm
          })
        Projects.data.content
          .filter((itm) => !itm.meta.system)
          .forEach((itm) => {
            itm.source = itm.type === 'project' ? '' : itm.meta?.partner ?? ''
            itm.status = itm.status.toUpperCase() === 'LIVE'
            itm._new = false
            itm._edit = false
            this.items.push(itm)
          })
        this.clonedItems = [...this.items, ...systemProjects]
        this.filteredBy = 'project'
      }
      // GET USERS WITH EXPERT ROLE
      this.ems = []
      const Users = await Services.Users.getUsersByRole('manager')
      if (Users.status == 200) {
        Users.data.content.forEach((user) => {
          this.ems.push({
            value: user.uid,
            text: `${user.firstName} ${user.lastName}`
          })
        })
      }
    },
    filterProjectType(type = 'project') {
      this.items = this.clonedItems.filter(
        (itm) => itm.type.toUpperCase() === type?.toUpperCase() ?? 'PROJECT'
      )
      this.filteredBy = type
    },
    searchProject(q = null) {
      if (q && q.trim().length) {
        // console.log('filtering...', this.filteredBy)
        this.items = this.clonedItems
          // .filter((itm) => {
          //   if (this.filteredBy) {
          //     return itm.type.toUpperCase() === this.filteredBy.toUpperCase()
          //   }
          // })
          .filter((itm) => {
            const qRegEx = new RegExp(`^${q.trim()}`, 'i')
            const title = qRegEx.test(itm.title.trim())
            const projectCode = qRegEx.test(itm.code.trim())
            return title || projectCode || q === itm.uid
          })
      } else {
        this.items = this.clonedItems.filter((itm) => {
          if (this.filteredBy) {
            return itm.type.toUpperCase() === this.filteredBy.toUpperCase()
          }
        })
      }
    },
    async addNew(type = 'PROJECT') {
      if (this.items.findIndex((itm) => itm._new) > -1) return
      const defaultProject = {
        type,
        code: null,
        title: '',
        client: null,
        partners: null,
        meta: {
          color: '#000',
          partner: null,
          projectName: '',
          ems: ''
        },
        status: 'CLOSED',
        sector: 'OTHER',
        todos: 'NTD',
        notes: '',
        totalassociates: 0,
        totalanalysts: 0,
        budget: 0,
        totalFees: 0,
        active: false,
        created: dateFormat(new Date(), 'yyyy-MM-dd'),
        deadline: null,
        _new: true,
        _edit: true
      }
      this.items.unshift(defaultProject)
    },
    async saveNew() {
      try {
        const toCreate = this.items.find((itm) => itm._new)
        if (toCreate?.length == 0 || typeof toCreate == 'undefined') return
        const { status } = await Services.Projects.Admin.create(toCreate)
        if (status == 200) {
          this.items = this.items.map((itm) => {
            itm._new = false
            itm._edit = false
            return itm
          })
          this.$bvToast.toast('Project created', {
            title: 'Success',
            variant: 'success',
            solid: true
          })
        }
      } catch (Exception) {
        this.items = this.items.splice(1)
        console.log(Exception?.response ?? Exception)
        // const defaultErrorMsg = 'Action Failed, Please contact Admin.'
        // const { status, code, details } = Exception?.response?.data?.error ?? {}
        // switch (true) {
        //   case status == 400 && code == 'VALIDATION_ERROR':
        //     this.$bvToast.toast(
        //       details.validationErrors[0]?.message ?? defaultErrorMsg,
        //       {
        //         title: 'Error',
        //         variant: 'danger',
        //         solid: true
        //       }
        //     )
        //     break
        //   default:
        //     this.$bvToast.toast(defaultErrorMsg, {
        //       title: 'Error',
        //       variant: 'danger',
        //       solid: true
        //     })
        // }
      }
    },
    async updateProject(project) {
      try {
        if (project._new) {
          await this.saveNew(project.type)
          return
        }
        await Services.Projects.Admin.update(project.uid, project)
      } catch (Exception) {
        throw Exception
      }
    }
  },
  watch: {
    filteredBy: {
      handler: function (val) {
        this.filterProjectType(val)
      },
      immediate: true
    }
  }
}
</script>

<style>
.cost-details-btn {
  font-size: 9pt !important;
  font-weight: bold;
  color: #6cf;
}
.lizard-column-fees {
  font-family: 'Courier New', Courier, monospace !important;
  font-size: 12px !important;
  font-weight: 100 !important;
}
.lizard-column-fees-disabled {
  color: #999;
}
/* .lizard-scroll and .lizard-candesic-table are styled centrally in
   src/styles/logs.css, so every table that uses them stays consistent and
   they no longer depend on this component happening to be loaded. */
</style>

<style scoped>
.lizard-activity-list {
  font-size: 12px !important;
  color: #666;
  font-weight: bold !important;
}
.lizard-column-index {
  text-align: center !important;
}
.lizard-form-empty-col {
  min-height: 20px !important;
}
.lizard-reports-stats li {
  display: inline-block;
}
.lizard-hourly-rate-input {
  text-align: center;
  width: 60px;
  max-width: 60px;
}
.lizard-date-input {
  text-align: center;
  width: 90px;
  max-width: 90px;
}
.header-msg {
  color: #666;
  font-weight: bold !important;
}
label {
  color: #666;
  line-height: 40px !important;
  font-weight: bold !important;
  font-size: 12px !important;
}
.txt {
  color: #666;
  font-weight: bold !important;
  font-size: 12px !important;
}
</style>
